import { createRouter, createMemoryHistory } from "vue-router";
import store from "../store";

const routes = [
  // {
  //   path: "/",
  //   name: "home",
  //   component: () => import("../views/LoginView.vue"),
  // },
  {
    path: "/",
    name: "home",
    component: () => import("../views/LandingView.vue"),
  },
  {
    path: "/LoginView",
    name: "LoginView",
    component: () => import("../views/LoginView.vue"),
  },
  {
    path: "/privacy-policy",
    name: "PrivacyPolicy",
    component: () => import("../views/PrivacyPolicyView.vue"),
  },
  {
    path: "/formmaster",
    name: "formmaster",
    component: () => import("../views/formmaster.vue"),
  },
  {
    path: "/mainlogin",
    name: "mainlogin",
    component: () => import("../views/mainlogin.vue"),
  },
  {
    path: "/employee_dashboard",
    name: "employee_dashboard",
    component: () => import("../views/EmployeeDashboard.vue"),
  },
  {
    path: "/account_dashboard",
    name: "account_dashboard",
    component: () => import("../views/AccountDashboard.vue"),

  },
  {
    path: "/hr_dashboard",
    name: "hr_dashboard",
    component: () => import("../views/HrDashboard.vue"),

  },
  {
    path: "/manager_dashboard",
    name: "manager_dashboard",
    component: () => import("../views/ManagerDashboard.vue"),

  },

  {
    path: "/admin_dashboard",
    name: "admin_dashboard",
    component: () => import("../views/AdminDashboard.vue"),
    meta: { requiresPrivilege: true },
  },
  {
    path: "/super_admin",
    name: "super_admin_dashboard",
    component: () => import("../views/SuperAdminDashboard.vue"),
    meta: { requiresPrivilege: true },
  },
  {
    path: "/dashboard2",
    name: "dashboard2",
    component: () => import("../views/DashboardView-old.vue"),
  },
  {
    path: "/role",
    name: "role",
    component: () => import("../views/role.vue"),
    meta: { requiresPrivilege: true },
  },
  {
    path: "/register",
    name: "register",
    component: () => import("../views/RegisterView.vue"),
  },
  {
    path: "/privacy-policy",
    name: "privacy-policy",
    component: () => import("../views/PrivacyPolicyView.vue"),
  },
  {
    path: "/income-tax",
    name: "income-tax",
    component: () => import("../components/IncomeTaxDetails.vue"),
  },
  {
    path: "/add-user/:user_id",
    name: "add-user",
    component: () => import("../views/AddUserMaster.vue"),
    meta: { requiresPrivilege: true },
  },
  {
    path: "/user-list",
    name: "user-list",
    component: () => import("../views/UserListView.vue"),
    meta: { requiresPrivilege: true },
  },
  {
    path: "/project",
    name: "project",
    component: () => import("../views/Project.vue"),
  },
  {
    path: "/attendanceRegularize-request",
    name: "attendanceRegularize-request",
    component: () => import("../views/AttendanceRegularizeList.vue"),
  },
  {
    // menu_url of the "Attendance Report" menu item (menu id 85, under Attendence)
    path: "/attendance-report",
    name: "attendance-report",
    component: () => import("../views/AttendanceRegisterView.vue"),
  },
  {
    // menu_url of the "Attendance Summary" menu item (next to Leaves, migration 0030)
    path: "/attendance-summary-report",
    name: "attendance-summary-report",
    component: () => import("../views/AttendanceSummaryReportView.vue"),
  },
  {
    // menu_url of the "Monthly Attendance Summary" menu item (under the same
    // group as Attendance Report, migration 0031)
    path: "/monthly-attendance-summary",
    name: "monthly-attendance-summary",
    component: () => import("../views/MonthlyAttendanceSummaryView.vue"),
  },
  {
    path: "/mstr-attendanceRegularize-request",
    name: "mstr-attendanceRegularize-request",
    component: () => import("../views/AttendanceRegularizeListMaster.vue"),

  },
  {
    path: "/displayAttendanceRegularize-request/:request_id",
    name: "displayAttendanceRegularize-request",
    component: () => import("../views/DisplayAttendanceRegularizeView.vue"),
  },
  {
    path: "/leave-request",
    name: "leave-request",
    component: () => import("../views/EmployeeLeave.vue"),
  },
  {
    // menu_url of the "WFH Request" menu item under the Work From Home menu.
    path: "/wfh-request",
    name: "wfh-request",
    component: () => import("../views/WFHRequestListView.vue"),
  },
  {
    path: "/displaywfh/:request_id",
    name: "wfh-request-detail",
    component: () => import("../views/WFHRequestDetailView.vue"),
  },
  {
    // menu_url of the "WFH Approval" menu item. Not privilege-gated: approval
    // authority is the reporting structure, which the API enforces; a user with
    // nobody reporting to them just sees an empty list.
    path: "/wfh-approval",
    name: "wfh-approval",
    component: () => import("../views/WFHApprovalListView.vue"),
  },
  {
    path: "/mstr-leave-request",
    name: "mstr-leave-request",
    component: () => import("../views/LeaveRequestListMaster.vue"),
  },
  {
    path: "/leaves",
    redirect: "/pmfdue/00000000-0000-0000-0000-000000000000"
  },
  {
    path: "/mstr-notification/",
    name: "mstr-notification",
    component: () => import("../views/NotificationListView.vue"),

  },
  {
    path: "/displayNotification/:notification_id",
    name: "displayNotification",
    component: () => import("../views/DisplayNotificationView.vue"),
  },
  {
    path: "/addNotification/:notification_id",
    name: "addNotification",
    component: () => import("../views/AddNotificationDetailView.vue"),
  },
  {
    path: "/pmfdue/:request_id",
    name: "pmfdue",
    component: () => import("../views/LeaveRequestView.vue"),
  },
  {
    path: "/attendance-regularise/:request_id",
    name: "attendance-regularise",
    component: () => import("../views/AttendanceRegulariseView.vue"),
  },
  {
    path: "/displayleave/:request_id",
    name: "displayleave",
    component: () => import("../views/DisplayLeaveDetailView.vue"),
  },
  {
    path: "/displayAttendanceDetail/:attendance_id",
    name: "displayAttendanceDetail",
    component: () => import("../views/DisplayAttendanceDetailView.vue"),
  },
  {
    path: "/attendence",
    name: "attendence",
    component: () => import("../views/AttendanceDetailView.vue"),
  },
  // {
  //   path: "/personal-details",
  //   name: "personal-details",
  //   component: () => import("../views/EmployeeAddEdit.vue"),
  // },
  {
    path: "/Information",
    name: "Information",
    component: () => import("../views/InformationCMSView.vue"),
  },
  {
    path: "/information-page/:slug",
    name: "information-page",
    component: () => import("../views/InformationPageView.vue"),
  },

  {
    path: "/employee-list",
    name: "employee-list",
    component: () => import("../views/EmployeeListView.vue"),

  },
  {
    path: "/paysheet",
    name: "paysheet",
    component: () => import("../views/PaySheetView.vue"),
  },
  {
    path: "/menu",
    name: "menu",
    component: () => import("../views/menu.vue"),
    meta: { requiresPrivilege: true },
  },
  {
    path: "/profile-view/:employee_id",
    name: "profileview",
    component: () => import("../views/ProfileView.vue"),
  },
  {
    path: "/display-tab/:employee_id",
    name: "displayAdminTab",
    component: () => import("../components/DisplayAdminTab.vue"),
  },
  {
    path: "/pay-structure",
    name: "pay-structure",
    component: () => import("../views/PayStructuredList.vue"),
    meta: { requiresPrivilege: true },
  },
  {
    path: "/define-pay-structure",
    name: "DefinePayStructure",
    component: () => import("../views/DefinePayStructure.vue"),
    meta: { requiresPrivilege: true },
  },
  {
    path: "/edit-define-pay-structure/:payroll_structure_id",
    name: "EditDefinePayStructure",
    component: () => import("../views/EditDefinePayStructure.vue"),
    meta: { requiresPrivilege: true },
  },
  {
    path: "/display-define-pay-structure/:payroll_structure_id",
    name: "DisplayDefinePayStructure",
    component: () => import("../views/DisplayDefinePayStructure.vue"),
    meta: { requiresPrivilege: true },
  },
  {
    path: "/EmployeeDetails/:employee_id",
    name: "EmployeeDetails",
    component: () => import("../views/EmployeeDetails.vue"),
  },
  {
    // Add/edit now happens in a modal on the Holiday List page.
    path: "/holidays/:holiday_id",
    name: "holidays",
    redirect: "/holiday-list",
  },
  // {
  //   path: "/company",
  //   name: "company",
  //   component: () => import("../views/CompanyView.vue"),
  // },
  // {
  //   path: "/branch",
  //   name: "branch",
  //   component: () => import("../views/BranchView.vue"),
  // },
  {
    path: "/departments-list",
    name: "departments-list",
    component: () => import("../views/DepartmentsListView.vue"),
  },
  // {
  //   path: "/departments/:department_id",
  //   name: "departments",
  //   component: () => import("../views/DepartmentView.vue"),
  // },
  {
    path: "/education_type-list",
    name: "education_type-list",
    component: () => import("../views/EducationTypeListView.vue"),
  },
  // {
  //   path: "/education_type/:education_type_id",
  //   name: "education_type",
  //   component: () => import("../views/EducationTypeView.vue"),
  // },
  {
    path: "/employment_status-list",
    name: "employment_status-list",
    component: () => import("../views/EmploymentStatusListView.vue"),
  },
  // {
  //   path: "/employment_status/:employment_status_id",
  //   name: "employment_status",
  //   component: () => import("../views/EmploymentStatusView.vue"),
  // },
  {
    path: "/leave_types-list",
    name: "leave_types-list",
    component: () => import("../views/LeaveTypesListView.vue"),

  },
  // {
  //   path: "/leave_types/:leave_type_id",
  //   name: "leave_types",
  //   component: () => import("../views/LeaveTypeView.vue"),
  // },
  {
    path: "/reimbursement/:id",
    name: "reimbursement",
    component: () => import("../views/AddReimbursementView.vue"),
  },
  {
    path: "/reimbursement-list",
    name: "reimbursement-list",
    component: () => import("../views/ReimbursementListView.vue"),
  },
  {
    path: "/displayReimbursement/:id",
    name: "displayReimbursement",
    component: () => import("../views/DisplayReimbursementDetails.vue"),
  },
  {
    path: "/mstr-reimbursement-list",
    name: "mstr-reimbursement-list",
    component: () => import("../views/ReimbursementListMasterView.vue"),

  },
  {
    path: "/expense",
    name: "expenseList",
    component: () => import("../views/ExpenseListView.vue"),
  },
  {
    path: "/displayExpense/:id",
    name: "displayExpense",
    component: () => import("../views/DisplayExpenseDetails.vue"),
  },
  // {
  //   path: "/designation/:designation_id",
  //   name: "designation",
  //   component: () => import("../views/DesignationView.vue"),
  // },
  {
    path: "/designation-list",
    name: "designation-list",
    component: () => import("../views/DesignationListView.vue"),
  },
  // {
  //   path: "/salary",
  //   name: "salary",
  //   component: () => import("../views/SalaryView.vue"),
  // },
  // {
  //   path: "/leave",
  //   name: "leave",
  //   component: () => import("../views/LeaveView.vue"),
  // },
  {
    path: "/holiday-list",
    name: "holiday-list",
    component: () => import("../views/HolidaysListView.vue"),
  },
  {
    path: "/payroll",
    name: "payroll",
    component: () => import("../views/AddpayrollView.vue"),
    meta: { requiresPrivilege: true },
  },
  {
    // Self-service -- an employee's own payslip. Backend
    // (GetEmployeePayslipMasterDetails) already hard-scopes non-privileged
    // callers to their own employee_id, so this page stays open.
    path: "/payslip",
    name: "payslip",
    component: () => import("../views/EmployeePayslip.vue"),
  },
  {
    path: "/reimbursement_paysheet",
    name: "reimbursement_paysheet",
    component: () => import("../views/ReimbursementPaysheet.vue"),
    meta: { requiresPrivilege: true },
  },
  {
    path: "/add-reimbursement_paysheet",
    name: "add-reimbursement_paysheet",
    component: () => import("../views/AddReimbursementPaysheetview.vue"),
    meta: { requiresPrivilege: true },
  },
  {
    path: "/form-24Q",
    name: "form-24Q",
    component: () => import("../components/IncomeTaxDetails24Q.vue"),
  },
  {
    path: "/leave-carry-forward",
    name: "leave-carry-forward",
    component: () => import("../views/LeaveCarryForward.vue"),
  },
  {
    path: "/display-leave-carry/:employee_id",
    name: "display-leave-carry",
    component: () => import("../views/DisplayLeaveCarryForword.vue"),
  },
  {
    path: "/qualification-list",
    name: "qualification-list",
    component: () => import("../views/QualificationListView.vue"),
  },
  // {
  //   path: "/qualification/:qualification_id",
  //   name: "qualification",
  //   component: () => import("../views/QualificationView.vue"),
  // },
  {
    path: "/payroll-deduction-list",
    name: "payroll-deduction-list",
    component: () => import("../views/PayrollDeductionItemMasterList.vue"),
  },
  // {
  //   path: "/payroll-deduction/:deduction_item_id",
  //   name: "payroll-deduction",
  //   component: () => import("../views/PayrollDeductionItemView.vue"),
  // },
  {
    path: "/payroll-earning-list",
    name: "payroll-earning-list",
    component: () => import("../views/PayrollEarningItemMasterList.vue"),
  },
  // {
  //   path: "/payroll-earning/:earning_item_id",
  //   name: "payroll-earning",
  //   component: () => import("../views/PayrollEarningItemView.vue"),
  // },
  {
    path: "/process-type-list",
    name: "process-type-list",
    component: () => import("../views/ProcessTypeList.vue"),
  },
  {
    path: "/rejection-reason-list",
    name: "rejection-reason-list",
    component: () => import("../views/RejectionReasonList.vue"),
  },
  {
    path: "/reimbursement-type-list",
    name: "reimbursement-type-list",
    component: () => import("../views/ReimbursementTypeList.vue"),
  },
  {
    path: "/location-list",
    name: "location-list",
    component: () => import("../views/LocationListView.vue"),
  },
  {
    path: "/exit-reason-list",
    name: "exit-reason-list",
    component: () => import("../views/ExitReasonListView.vue"),
  },
  {
    path: "/employee-no-prefix-list",
    name: "employee-no-prefix-list",
    component: () => import("../views/EmployeeNoPrefixListView.vue"),
  },
  {
    path: "/attendanceRegularize-reason-list",
    name: "attendanceRegularize-reason-list",
    component: () => import("../views/AttendanceRegularizeReasonlist.vue"),
  },
  {
    path: "/taxSlab-list",
    name: "taxSlab-list",
    component: () => import("../views/TaxSlabListView.vue"),
  },
  {
    path: "/annualYearLeave-list",
    name: "annualYearLeave-list",
    component: () => import("../views/AnnualYearLeaveList.vue"),

  },
  {
    path: "/view-attendance",
    name: "view-attendance",
    component: () => import("../views/ViewAttendance.vue"),
  },
  {
    path: "/attendance-calendar",
    name: "attendance-calendar",
    component: () => import("../views/AttendanceCalendarView.vue"),
  },
  {
    path: "/task-list",
    name: "task-list",
    component: () => import("../views/TaskListView.vue"),
  },
  {
    path: "/task-add",
    name: "task-add",
    component: () => import("../views/TaskAddView.vue"),
  },
  {
    path: "/task-edit/:id",
    name: "task-edit",
    component: () => import("../views/TaskEditView.vue"),
  },
  {
    path: "/task-view/:id",
    name: "task-view",
    component: () => import("../views/TaskView.vue"),
  },
  {
    path: "/sprint-list",
    name: "sprint-list",
    component: () => import("../views/SprintListView.vue"),
  },
  {
    path: "/sprint-add",
    name: "sprint-add",
    component: () => import("../views/SprintAddView.vue"),
  },
  {
    path: "/sprint-edit/:id",
    name: "sprint-edit",
    component: () => import("../views/SprintEditView.vue"),
  },

  // ─── Project Master ─────────────────────────────────────────────────────────
  {
    path: "/project-list",
    name: "project-list",
    component: () => import("../views/Project.vue"),
  },



  {
    path: "/projects",
    name: "sf-projects",
    component: () => import("../views/SFProjectListView.vue"),
  },
  {
    path: "/project-add",
    name: "sf-project-add",
    component: () => import("../views/SFProjectAddView.vue"),
  },
  {
    path: "/project-edit/:id",
    name: "sf-project-edit",
    component: () => import("../views/SFProjectEditView.vue"),
  },
  {
    path: "/backlog",
    name: "sf-backlog-all",
    component: () => import("../views/SFBacklogView.vue"),
  },
  {
    path: "/backlog/:projectId",
    name: "sf-backlog",
    component: () => import("../views/SFBacklogView.vue"),
  },
  {
    path: "/backlog-add",
    name: "sf-backlog-add-all",
    component: () => import("../views/SFBacklogItemAddView.vue"),
  },
  {
    path: "/backlog-add/:projectId",
    name: "sf-backlog-add",
    component: () => import("../views/SFBacklogItemAddView.vue"),
  },
  {
    path: "/backlog-edit/:id",
    name: "sf-backlog-edit",
    component: () => import("../views/SFBacklogItemEditView.vue"),
  },
  {
    path: "/sprint-plan",
    name: "sf-sprint-plan-all",
    component: () => import("../views/SFSprintPlanView.vue"),
  },
  {
    path: "/sprint-plan/:projectId",
    name: "sf-sprint-plan",
    component: () => import("../views/SFSprintPlanView.vue"),
  },
  {
    path: "/board",
    name: "sf-board-all",
    component: () => import("../views/SFSprintBoardView.vue"),
  },
  {
    path: "/board/:sprintId",
    name: "sf-board",
    component: () => import("../views/SFSprintBoardView.vue"),
  },
  {
    path: "/burndown/:sprintId",
    name: "sf-burndown",
    component: () => import("../views/SFBurndownView.vue"),
  },
  {
    path: "/reports",
    name: "sf-reports-all",
    component: () => import("../views/SFReportsView.vue"),
  },
  {
    path: "/reports/:projectId",
    name: "sf-reports",
    component: () => import("../views/SFReportsView.vue"),
  },

  // ─── SprintForge — Hotfix ────────────────────────────────────────────────────
  {
    path: "/hotfix",
    name: "sf-hotfix",
    component: () => import("../views/SFHotfixView.vue"),
  },
  {
    path: "/hotfix-edit/:id",
    name: "sf-hotfix-edit",
    component: () => import("../views/SFHotfixEditView.vue"),
  },

  // ─── SprintForge — Daily Standup (DSM) ──────────────────────────────────────
  {
    path: "/dsm",
    name: "sf-dsm-all",
    component: () => import("../views/DSMListView.vue"),
  },
  {
    path: "/dsm/:projectId",
    name: "sf-dsm-list",
    component: () => import("../views/DSMListView.vue"),
  },
  {
    path: "/dsm/session/:sessionId",
    name: "sf-dsm-session",
    component: () => import("../views/DSMSessionView.vue"),
  },
  {
    path: "/dsm/entry/:sessionId",
    name: "sf-dsm-entry",
    component: () => import("../views/DSMEntryView.vue"),
  },

  // ---- MRF (Manpower Requisition Form) ----
  {
    path: "/mrf-list",
    name: "mrf-list",
    component: () => import("../views/MRFListView.vue"),
  },
  {
    path: "/mrf/add",
    name: "mrf-add",
    component: () => import("../views/AddEditMRFView.vue"),
  },
  {
    path: "/mrf/edit/:mrf_id",
    name: "mrf-edit",
    component: () => import("../views/AddEditMRFView.vue"),
  },
  {
    path: "/mrf/view/:mrf_id",
    name: "mrf-view",
    component: () => import("../views/DisplayMRFView.vue"),
  },
  {
    path: "/job-description-list",
    name: "job-description-list",
    component: () => import("../views/JobDescriptionListView.vue"),
  },
  {
    path: "/job-description/add",
    name: "job-description-add",
    component: () => import("../views/AddEditJobDescriptionView.vue"),
  },
  {
    path: "/job-description/edit/:jd_id",
    name: "job-description-edit",
    component: () => import("../views/AddEditJobDescriptionView.vue"),
  },

  // ---- Training (CMMI ML3) ----
  // No meta.requiresPrivilege: what each person may do comes from the Training
  // API's GetTrnMyPermissions (employee / manager baselines included), and
  // every route re-checks on the server. Everyone may browse the catalog.
  {
    path: "/training/courses",
    name: "trn-course-list",
    component: () => import("../views/TrnCourseListView.vue"),
  },
  // Must stay above /training/courses/:course_id, or "add" is read as an id.
  {
    path: "/training/courses/add",
    name: "trn-course-add",
    component: () => import("../views/TrnCourseFormView.vue"),
  },
  {
    path: "/training/courses/:course_id/edit",
    name: "trn-course-edit",
    component: () => import("../views/TrnCourseFormView.vue"),
  },
  {
    path: "/training/courses/:course_id",
    name: "trn-course-detail",
    component: () => import("../views/TrnCourseDetailView.vue"),
  },
  {
    path: "/training/competencies",
    name: "trn-competency-list",
    component: () => import("../views/TrnCompetencyListView.vue"),
  },
  {
    path: "/training/trainers",
    name: "trn-trainer-list",
    component: () => import("../views/TrnTrainerListView.vue"),
  },
  {
    path: "/training/competency-matrix",
    name: "trn-competency-matrix",
    component: () => import("../views/TrnCompetencyMatrixView.vue"),
  },
  {
    path: "/training/competency-profile",
    name: "trn-competency-profile",
    component: () => import("../views/TrnCompetencyProfileView.vue"),
  },
  {
    path: "/training/tna",
    name: "trn-tna-list",
    component: () => import("../views/TrnTnaListView.vue"),
  },
  {
    path: "/training/tna/:tna_id",
    name: "trn-tna-detail",
    component: () => import("../views/TrnTnaView.vue"),
  },
  {
    path: "/training/plans",
    name: "trn-plan-list",
    component: () => import("../views/TrnPlanListView.vue"),
  },
  {
    path: "/training/plans/:plan_id",
    name: "trn-plan-detail",
    component: () => import("../views/TrnPlanView.vue"),
  },
  {
    path: "/training/sessions",
    name: "trn-session-list",
    component: () => import("../views/TrnSessionListView.vue"),
  },
  {
    path: "/training/sessions/:session_id/attendance",
    name: "trn-session-attendance",
    component: () => import("../views/TrnSessionAttendanceView.vue"),
  },
  {
    path: "/training/sessions/:session_id",
    name: "trn-session-detail",
    component: () => import("../views/TrnSessionView.vue"),
  },
  {
    path: "/training/waivers",
    name: "trn-waiver-list",
    component: () => import("../views/TrnWaiverListView.vue"),
  },
  {
    path: "/training/my-training",
    name: "trn-my-training",
    component: () => import("../views/TrnMyTrainingView.vue"),
  },
  {
    path: "/training/team",
    name: "trn-team",
    component: () => import("../views/TrnTeamView.vue"),
  },
  {
    // No employee_id = the caller's own transcript.
    path: "/training/transcript/:employee_id?",
    name: "trn-transcript",
    component: () => import("../views/TrnTranscriptView.vue"),
  },
  {
    path: "/training/dashboard",
    name: "trn-dashboard",
    component: () => import("../views/TrnDashboardView.vue"),
  },
  {
    path: "/training/evidence-pack",
    name: "trn-evidence-pack",
    component: () => import("../views/TrnEvidencePackView.vue"),
  },

  // ---- Employee Exit (Exit Request / Exit Interview) ----
  {
    path: "/exit-request-list",
    name: "exit-request-list",
    component: () => import("../views/ExitRequestListView.vue"),
  },
  {
    path: "/exit-interview/:exit_request_id",
    name: "exit-interview",
    component: () => import("../views/ExitInterviewView.vue"),
  },

  // ---- Employee Exit Workflow (dedicated: New / Discuss / Forward to HR /
  // Exit Interview / Approved / Cancelled) ----
  // One menu entry for everyone: /exit-workflow/inbox. The page picks the
  // list from the logged-in role — HR/Admin get the HR list (plus a My Team
  // tab, ?view=TEAM), everyone else gets their direct reports' requests.
  // Must stay above /exit-workflow/:exit_request_id, or "inbox" is read as an id.
  {
    path: "/exit-workflow/inbox",
    name: "exit-workflow-inbox",
    component: () => import("../views/ExitWorkflowInboxView.vue"),
  },
  // Old per-view URLs (/exit-workflow/inbox/TEAM | /HR), kept for bookmarks.
  {
    path: "/exit-workflow/inbox/:view",
    redirect: (to) => ({ path: "/exit-workflow/inbox", query: { view: String(to.params.view || "").toUpperCase() } }),
  },
  {
    path: "/exit-workflow/:exit_request_id",
    name: "exit-workflow-detail",
    component: () => import("../views/ExitWorkflowDetailView.vue"),
  },

  // ---- Recruitment Tracker + Personnel-File (RTM) ----
  {
    path: "/recruitment-tracker",
    name: "recruitment-tracker-list",
    component: () => import("../views/RecruitmentTrackerListView.vue"),
  },
  {
    path: "/recruitment-tracker/view/:pipeline_id",
    name: "recruitment-tracker-view",
    component: () => import("../views/RecruitmentTrackerDetailView.vue"),
  },

];

// Routes are kept in memory so the address bar never shows the page path
// (always just the base URL). The current route is remembered per tab in
// sessionStorage so a refresh reopens the same page. A path typed/linked
// directly (e.g. from an email) is still honoured once, then hidden.
const BASE = process.env.BASE_URL || "/";
const CURRENT_ROUTE_KEY = "currentRoute";
const memoryHistory = createMemoryHistory(BASE);

const typedPath =
  "/" +
  window.location.pathname.slice(BASE.length).replace(/^\/+/, "") +
  window.location.search;
let startPath = typedPath;
if (typedPath === "/") {
  try {
    startPath = sessionStorage.getItem(CURRENT_ROUTE_KEY) || "/";
  } catch (e) {
    startPath = "/";
  }
}
memoryHistory.replace(startPath);
window.history.replaceState(window.history.state, "", BASE);

const router = createRouter({
  history: memoryHistory,
  routes,
});

router.afterEach((to) => {
  try {
    sessionStorage.setItem(CURRENT_ROUTE_KEY, to.fullPath);
  } catch (e) {
    // storage unavailable -- refresh will just land on "/"
  }
});

// Helper function to check if token is expired
function isTokenExpired(token) {
  if (!token) return true;
  try {
    const base64Url = token.split('.')[1];
    const base64 = base64Url.replace(/-/g, '+').replace(/_/g, '/');
    const jsonPayload = decodeURIComponent(atob(base64).split('').map(function (c) {
      return '%' + ('00' + c.charCodeAt(0).toString(16)).slice(-2);
    }).join(''));
    const decoded = JSON.parse(jsonPayload);

    if (!decoded.exp) return false; // If no expiration, consider valid

    // Check if token is expired (exp is in seconds, Date.now() is in milliseconds)
    const currentTime = Math.floor(Date.now() / 1000);
    return decoded.exp < currentTime;
  } catch (e) {
    return true; // If parsing fails, consider token invalid
  }
}
const applyLeave = () => {
  router.push({
    name: "pmfdue",
    params: {
      request_id: "00000000-0000-0000-0000-000000000000",
    },
  });
};

// Navigation Guard: Protect all pages except Login, Landing and Register
router.beforeEach((to, from, next) => {
  const publicPages = ["/", "/LoginView", "/register", "/LandingView", "/privacy-policy"];
  const authRequired = !publicPages.includes(to.path);
  const token = sessionStorage.getItem("userToken") || store.getters.authToken;
  const isLoggedIn = !!token && !isTokenExpired(token);

  if (authRequired && !isLoggedIn) {
    // Clear invalid session data
    sessionStorage.removeItem('userToken');
    sessionStorage.removeItem('user');
    sessionStorage.removeItem('isLoggedIn');
    store.commit('LOGOUT');
    return next("/LoginView");
  }

  // Additional check: If user is on a protected route and their token is invalid, logout
  if (isLoggedIn && isTokenExpired(token)) {
    sessionStorage.removeItem('userToken');
    sessionStorage.removeItem('user');
    sessionStorage.removeItem('isLoggedIn');
    store.commit('LOGOUT');
    return next("/LoginView");
  }

  // Role/permission check -- previously this guard only verified
  // authentication, so any logged-in user of any role could navigate
  // directly to an admin-only URL (role/user/menu management, payroll,
  // etc.) and the page would fully render; only the sidebar not linking to
  // it stood in the way. Routes that flag meta.requiresPrivilege now also
  // require the backend-computed is_privileged flag (from /getUserDetails,
  // the same signal the corresponding APIs already gate on).
  if (to.meta?.requiresPrivilege && !store.getters.isPrivileged) {
    // Deliberately always "/" (public, no auth/privilege required) rather
    // than the role's own Dashboard_link -- that value is server/role
    // driven data this guard can't fully vet against the routes just
    // flagged above, and a bad value there could otherwise loop.
    return next("/");
  }

  next();
});

export default router;
